/* eslint-disable one-var */
let _ = require('lodash')
let _moment = require('moment')

import getSecret from '@utils/get-secret'
import i18n from '@plugins/i18n';

export default {
  install(Vue) {
    // 1. add global method or property
    Vue.prototype.$generate_noty = (notyType, text, title, duration, toast_mode) => {
      let opt = {
        duration: duration || 5000, // duration of the notify
        text: text,
      }
      let variant = 'info'
      if (notyType === 'error' || notyType === 'danger') {
        opt['type'] = 'error'
        opt['title'] = i18n.t('alerts.error')
        variant = 'danger'
      } else if (notyType === 'success') {
        opt['type'] = 'success'
        opt['title'] = i18n.t('alerts.success')
        variant = 'success'
      } else if (notyType === 'warn' || notyType === 'warning') {
        opt['type'] = 'warn'
        opt['title'] = i18n.t('alerts.warning')
        variant = 'warning'
      } else {
        opt['title'] = i18n.t('alerts.info')
      }
      //  Vue.prototype.$notify(opt)
      const Toast = Vue.prototype.$swal.mixin({
        toast: toast_mode,
        icon: toast_mode ? variant : undefined,
        timerProgressBar: duration ? true : false,
        confirmButtonText: !toast_mode ? i18n.t('basic.accept') : undefined,
        showConfirmButton: toast_mode ? false : true,
        showCloseButton: true,
        position: toast_mode ? 'top-right' : 'center',
        width: !toast_mode ? 600 : undefined,
        customClass: {
          popup: toast_mode ? `colored-toast swal2-toast-${variant}` : undefined,
          backdrop: 'swal2-backdrop-show swal2-backdrop-' + variant,
          title: 'text-' + variant,
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-default'
        },
        showClass: !toast_mode ? {
          backdrop: 'swal2-backdrop-show swal2-backdrop-' + variant,
        } : {}
      });
      Toast.fire({
        icon: variant === 'danger' ? 'error' : variant,
        title: toast_mode ? text || title || opt['title'] : title || opt['title'],
        html: !toast_mode ? text : undefined,
        timer: duration,
      })
      // const Toast = Vue.prototype.$swal.mixin({
      //   toast: true,
      //   position: 'top-right',
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast'
      //   },
      //   showConfirmButton: false,
      //   timer: 1500000,
      //   timerProgressBar: true
      // })

      // Toast.fire({
      //   icon: 'error',
      //   title: 'Connected Successfully'
      // })

    }



    Vue.prototype.$generate_toast = (
      vm,
      notyType,
      text,
      title,
      duration,
      toaster
    ) => {
      let opt = {
        toaster: toaster || 'b-toaster-top-right', // default toaster
        autoHideDelay: duration || 5000, // duration of the notify
        solid: true,
      }
      if (notyType === 'error') {
        opt['variant'] = 'danger'
        opt['title'] = title || i18n.t('alerts.error')
      } else if (notyType === 'success') {
        opt['variant'] = 'success'
        opt['title'] = title || i18n.t('alerts.success')
      } else if (notyType === 'warn' || notyType === 'warning') {
        opt['variant'] = 'warning'
        opt['title'] = title || i18n.t('alerts.warning')
      } else {
        opt['variant'] = 'info'
        opt['title'] = title || i18n.t('alerts.info')
      }
      vm.$bvToast.toast(text, opt)
    }
    Vue.prototype.$axios_error_noty = (e, vm) => {
      // Receives an axios catched error
      if (e.response) {
        if (e.response.status === 403 && 'data' in e.response) {
          if (vm) {
            Vue.prototype.$generate_toast(vm, 'error', e.response.data.detail)
          } else {
            Vue.prototype.$generate_noty('error', e.response.data.detail)
          }
        } else if (e.response.status === 404 && 'data' in e.response) {
          if (vm) {
            Vue.prototype.$generate_toast(
              vm,
              'error',
              `Error 404, ${e.response.data.detail}`
            )
          } else {
            Vue.prototype.$generate_noty(
              'error',
              `Error 404, ${e.response.data.detail}`
            )
          }
        } else if (e.response.status === 400) {
          Object.keys(e.response.data).forEach((key) => {
            if (vm) {
              if (typeof e.response.data[key] != 'string') {
                Object.keys(e.response.data[key]).forEach((key2) => {
                  Vue.prototype.$generate_toast(
                    vm,
                    'error',
                    e.response.data[key][key2],
                    _.startCase(key)
                  )
                })
              } else {
                Vue.prototype.$generate_toast(
                  vm,
                  'error',
                  e.response.data[key],
                  _.startCase(key)
                )
              }
            } else {
              Vue.prototype.$generate_noty(
                'error',
                `<b>${_.startCase(key)}</b><br/>${e.response.data[key]}`
              )
            }
          })
        } else if (e.response.status === 401) {
          if (vm) {
            vm.$router.push({
              name: 'logout',
              params: { expiredSession: true },
            })
          } else {
            Vue.prototype.$generate_noty(
              'error',
              'Your session has expired, please log in again'
            )
          }
        } else if (e.response.status === 500) {
          if (vm) {
            Vue.prototype.$generate_toast(vm, 'error', 'Internal server error')
          } else {
            Vue.prototype.$generate_noty('error', 'Internal server error')
          }
        }
      } else {
        if (vm) {
          Vue.prototype.$generate_toast(vm, 'error', e.message)
        } else {
          Vue.prototype.$generate_noty('error', e.message)
        }
      }
    }

    Vue.prototype.$table_params = (ctx) => {
      /* Receive a vue datatable filters: 
          {
              apiUrl: ""
              currentPage: 1
              filter: null
              perPage: 0
              sortBy: ""
              sortDesc: false
          }
      */
      if (!ctx) return ''

      let query = ''
      if (ctx.filterset) {
        query = query ? query + `&${ctx.filterset}` : `${ctx.filterset}`
      }
      if (ctx.filter) {
        query = query
          ? query + `&search=${ctx.filter}`
          : query + `search=${ctx.filter}`
      }
      if (ctx.perPage || ctx.perpage) {
        query = query
          ? query + `&page_size=${ctx.perPage || ctx.perpage}`
          : query + `page_size=${ctx.perPage || ctx.perpage}`
      }
      if (ctx.currentPage || ctx.currentpage) {
        query = query
          ? query + `&page=${ctx.currentPage || ctx.currentpage}`
          : query + `page=${ctx.currentPage || ctx.currentpage}`
      }
      if (ctx.sortBy || ctx.sortby) {
        if (ctx.sortDesc || ctx.sortdesc) {
          query = query
            ? query + `&ordering=${ctx.sortBy || ctx.sortby}`
            : query + `ordering=${ctx.sortBy || ctx.sortby}`
        } else {
          query = query
            ? query + `&ordering=-${ctx.sortBy || ctx.sortby}`
            : query + `ordering=-${ctx.sortBy || ctx.sortby}`
        }
      }
      return query ? `?${query}` : query
    }

    Vue.prototype.$table_params_object = (ctx) => {
      /* Receive a vue datatable filters: 
        {
          apiUrl: ""
          currentPage: 1
          filter: null
          perPage: 0
          sortBy: ""
          sortDesc: false
        }
      */

      let query = {}
      if (ctx.filter) {
        query.search = ctx.filter
      }
      if (ctx.perPage) {
        query.page_size = ctx.perPage
      }
      if (ctx.currentPage) {
        query.page = ctx.currentPage
      }
      if (ctx.sortBy) {
        if (ctx.sortDesc) {
          query.ordering = ctx.sortBy
        } else {
          query.ordering = `-${ctx.sortBy}`
        }
      }
      return query
    }

    Vue.prototype.$select_params = (searchQuery) => {
      /* Receive a vue multiselect query filter: */
      let query = '?page_size=9999&origin=multiselect'
      return searchQuery ? `${query}&search=${searchQuery}` : query
    }

    Vue.prototype.$select_params_standard = (searchQuery) => {
      /* Receive a vue multiselect query filter: */
      let query = '?page_size=200'
      return searchQuery ? `${query}&search=${searchQuery}` : query
    }


    Vue.prototype.$syllabify = (word) => {
      // Test it: console.log(['away', 'hair', 'halter', 'hairspray', 'father', 'lady', 'kid'].map(syllabify))
      // Return an array with each sillable
      const syllableRegex = /[^aeiouy]*[aeiouy]+(?:[^aeiouy]*$|[^aeiouy](?=[^aeiouy]))?/gi
      return word.match(syllableRegex)
    }

    Vue.prototype.$truncateWords = (word, n) => {
      return word.substr(0, n - 1) + (word.length > n ? '...' : '')
    }

    Vue.prototype.$arraySuffle = (array) => {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }

      return array
    }

    Vue.prototype.$getSecret = (key) => {
      return getSecret(key)
    }

    Vue.prototype.$uuidv4 = () => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }

    Vue.prototype.$initials = (name) => {
      let words = name.split(' ')
      return words.map((word) => word && word[0].toUpperCase()).join('');
    }

    Vue.prototype.$strfDatetime = (datetime) => {
      return _moment(datetime).format('YYYY-MM-D hh:mm:ss a');;
    }

    Vue.prototype.$strfDate = (datetime) => {
      return _moment(new Date(datetime)).format('L');
    }

    Vue.prototype.$datetimesDiff = (datetime1, datetime2) => {
      var date1 = _moment(datetime1);
      var date2 = _moment(datetime2);
      return date2.diff(date1);
    }

    Vue.prototype.$generateRandomId = (length = 8) => {
      const charset = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let randomId = '';
      for (var i = 0, n = charset.length; i < length; ++i) {
        randomId += charset.charAt(Math.floor(Math.random() * n));
      }
      return randomId;
    }
    // COP 
    Vue.prototype.$formatCurrency = (value) => {
      const localeCurrency = Intl.NumberFormat('en-GB')
      return localeCurrency.format(value)
    }
    Vue.prototype.$formatDateLatam = (value) => {
      let values = value.split("-");
      let dia = values[2];
      let mes = values[1];
      let ano = values[0];
      return `${dia}-${mes}-${ano}`
    }
  },
}
